var _path, _path2, _path3, _path4, _line, _path5, _path6, _line2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12,2.62C6.82,2.62,2.62,6.82,2.62,12s4.199,9.38,9.38,9.38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12,21.38c5.18,0,9.38-4.199,9.38-9.38S17.18,2.62,12,2.62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12,2.62c-2.59,0-4.69,4.199-4.69,9.38s2.1,9.38,4.69,9.38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12,2.62c2.59,0,4.69,4.199,4.69,9.38s-2.1,9.38-4.69,9.38"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2.62,
    x2: 12,
    y2: 21.38
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m19.269,17.062c-1.72-1.053-4.337-1.726-7.269-1.726s-5.55.673-7.27,1.727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m19.269,6.937c-1.72,1.053-4.338,1.726-7.269,1.726s-5.55-.673-7.27-1.726"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.62,
    y1: 12,
    x2: 21.38,
    y2: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.11d6a16d76f8a55cbc5f89c6bf7f9a9d.svg";
export { ForwardRef as ReactComponent };